<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator />
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white  cs-contentContainer-right-content cs-fullHeight" v-show="!workflowVisible">
            <el-row>
              <el-col>
                <breadcrumbNavigationBar :data="breadcrumbNavigationBarData"></breadcrumbNavigationBar>
              </el-col>
            </el-row>
            <el-row>
              <el-col>&nbsp;</el-col>
            </el-row>
            <div v-loading="isLoadingStudent">
              <el-row type="flex" class="student-container">
                <el-col :span="16">
                  <studentInfo mode="simple" :showChannel="!USERMANAGER.isStudent" :enableEdit="!readonly" :dataIn="studentInfoDataIn" @change="onStudentInfoChange" @channelChange="onChannelChange"/>
                </el-col>
                <el-col v-if="!readonly" :span="8" class="action-container">
                  <el-button v-if="!isLoadingStudent" type="primary" @click="onAddSAWServicesClick">添加服务</el-button>
                </el-col>
              </el-row>
              <el-divider />
              <el-row class="grid-content">
                <el-col>
                  <pagination v-loading="isLoading" :data="paginationData" :option="paginationOption" @loadData="onTableLoadData"
                    @pageSizeChange="onTablePageSizeChange" @currentPageChange="onTableCurrentPageChange" @edit="onTableEdit" @delete="onTableDelete" />
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="backgroud-white cs-fullHeight cs-studyAbroad-workflow-container" v-if="workflowVisible">
            <workflow :studentId="saStudent.StudentId" :channelId="saStudent.ChannelId" :countryCode="saStudent.ChannelCountryCode || GLOBAL.enumCountryCode.Canada" :currency="saStudent.ChannelCurrency || GLOBAL.currencyType.CAD" :isBottomPriceMode="saStudent.IsBottomPriceMode" @close="onWorkflowClose" />
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { ObjectEx } from "vue-objectex";

import {
  getStudyAbroadStudent,
  getStudyAbroadWorkflowServicePageData,
  closeSAWorkflowServiceById,
} from "@/service/studyAbroad.service";
import { compileStr } from "@/config/mUtils";

const defaultSAStudent = {
  StudentId: 0,
  StudentName: null,
  Phone: null,
  SaleAmountDiscountedCAD: 0,
  SaleAmountDiscountedCNY: 0,
  SaleAmountAvailableCAD: 0,
  SaleAmountAvailableCNY: 0,
  WorkflowCurrencyList: [],
  ChannelId: null,
  ChannelName: null,
  ChannelCurrency: null,
};

const mixin_bnBar = {
  components: {
    breadcrumbNavigationBar: () =>
      import("@/components/common/breadcrumbNavigationBar"),
  },
  data() {
    return {
      navName: "真留服务列表",
      breadcrumbNavigationBarData: new ObjectEx(
        [
          {
            key: "name",
            value: "真留",
          },
          {
            key: "currentName",
            value: this.$route.meta.navName,
          },
          {
            key: "navList",
            value: [
              {
                link: "/studyAbroad/studentList",
                name: "真留学员列表",
              },
            ],
          },
        ],
        {
          updateCurrentName(newValue) {
            this.currentName = newValue;
          },
          updateNavList(newNavList) {
            this.navList = newNavList;
          },
        }
      ),
    };
  },
  created() {
    this.$nextTick(() => {
      if (!!this.$route.meta.navName) {
        this.navName = this.$route.meta.navName;
        this.breadcrumbNavigationBarData.updateCurrentName(this.navName);
      }
      this.updateNavListByRoute();
    });
  },
  methods: {
    updateNavListByRoute() {
      let navList = [];
      try {
        navList = this.$cryptoJS.enc.Base64.decode(this.routeQuery.navList);
        navList = JSON.parse(navList);
      } catch (error) {}
      if (Object.typeOf(navList) !== "array") return;

      let bnbNavList = [];
      navList.forEach((nav) => {
        let name;
        switch (nav.path) {
          case "/studyAbroad/studentList":
            name = "真留学员列表";
            break;
        }

        if (!!name) {
          if (bnbNavList.length === 0) this.$route.meta.menuActive = nav.path;
          bnbNavList.push({
            basePath: nav.path,
            link: nav.path,
            name,
            data: nav.data,
          });
        }
      });
      this.breadcrumbNavigationBarData.updateNavList(bnbNavList);
    },
  },
};

const mixin_generalMethods = {
  methods: {
    getSearchPageData(pageNumber = 1) {
      this.currentPageNumber = pageNumber;
      let additionalFilter = {
        StudentId: this.studentId,
      };

      let pageData = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        additionalFilter: additionalFilter,
      };
      return pageData;
    },
  },
};

export default {
  name: "studentServiceDetail",
  mixins: [mixin_bnBar, mixin_generalMethods],
  components: {
    navigator: () => import("@/components/navigator"),
    studentInfo: () => import("@/components/studyAbroad/studentInfo"),
    pagination: () => import("@/components/common/pagination"),
    workflow: () => import("@/components/studyAbroad/workflow/main"),
  },
  data() {
    let readonly = this.USERMANAGER.isSAFinancialAssistant || this.USERMANAGER.isStudent;
    return {
      readonly: readonly,
      routeQuery: {},
      studentId: 0,
      saStudent: Object.clone(defaultSAStudent),
      studentInfoDataIn: {
        studentId: 0,
        studentData: null,
      },
      workflowVisible: false,
      isLoading: false,
      isLoadingStudent: false,
      pageSize: 20,
      currentPageNumber: 1,
      paginationOption: {
        displayPagination: false,
        hasEditButton: true,
        hasAddButton: false,
        editButtonText: "查看详情",
        hasDeleteButton: !readonly,
        deleteButtonText: "关闭服务",
        fnCustomCellClass: (col, row) => {
          return {
            "color-status": col.IsColorLabel,
            "color-status-inProgress":
              row.ServiceStatus ===
              this.GLOBAL.enumStudyAbroadStatus.InProgress,
            "color-status-completed":
              row.ServiceStatus === this.GLOBAL.enumStudyAbroadStatus.Completed,
            "color-status-closed":
              row.ServiceStatus === this.GLOBAL.enumStudyAbroadStatus.Closed ||
              row.ServiceStatus === this.GLOBAL.enumStudyAbroadStatus.Refund,
          };
        },
        fnRowDeleteVisible: (index, row) => {
          return (
            row.ServiceStatus !== this.GLOBAL.enumStudyAbroadStatus.Completed
          );
        },
      },
      paginationData: {},
    };
  },
  created() {
    this.routeQuery = this.$route.query;
    switch (this.$route.path) {
      case "/saServiceList":
        this.studentId = this.USERMANAGER.studentId;
        this.readonly = true;
        break;
      default:
        this.studentId = `${this.routeQuery.studentId}`.toNumber();
        break;
    }

    this.$nextTick(async () => {
      await this.loadSAStudentFromServer();
      await this.search();
    });
  },
  methods: {
    // 从服务端获取数据相关方法
    async loadSAStudentFromServer() {
      if (!this.studentId) return;
      this.isLoadingStudent = true;
      let result = await getStudyAbroadStudent(this.studentId);
      this.isLoadingStudent = false;
      this.saStudent =
        !!result && result.success && !!result.data
          ? result.data
          : Object.clone(defaultSAStudent);
    },
    async loadSAWServicePageDataFromServer(pageData) {
      this.isLoading = true;

      try {
        let result = await getStudyAbroadWorkflowServicePageData(pageData);
        if (!!result && result.success) {
          this.paginationData = result.data;
        }
      } catch (error) {}

      this.isLoading = false;
    },
    async closeSAWorkflowServiceByIdToServer(id, closeDate) {
      let result = await closeSAWorkflowServiceById(id, closeDate);
      if (!result || !result.success) {
        this.$message.error(result.message);
        return false;
      }

      this.$message({
        message: "结束服务成功",
        type: "success",
      });

      this.$nextTick(async () => {
        await this.loadSAStudentFromServer();
        await this.search();
      });

      return true;
    },

    // StudentInfo相关方法
    resetStudentInfoDataIn() {
      let studentData =
        !!this.saStudent && !!this.saStudent.StudentId ? this.saStudent : null;

      this.studentInfoDataIn = {
        studentId: !!studentData ? studentData.StudentId : this.studentId,
        studentData: studentData,
      };
    },
    onStudentInfoChange(dataOut) {
      if (dataOut.StudentId !== this.saStudent.StudentId) return;

      Object.entries(dataOut.FieldsValue).forEach((entry) => {
        this.saStudent[entry[0]] = entry[1];
      });
    },
    onAddSAWServicesClick() {
      // if (!this.saStudent.ChannelId) {
      //   this.$message.warning("未设置渠道");
      //   return;
      // }
      // if (!this.saStudent.ChannelCurrency) {
      //   this.$message.warning("渠道未设置币种");
      //   return;
      // }
      this.workflowVisible = true;
    },
    onWorkflowClose(isReload) {
      this.workflowVisible = false;
      if (isReload) {
        this.$nextTick(async () => {
          await this.loadSAStudentFromServer();
          await this.search();
        });
      }
    },
    // SeviceTable相关方法
    async search(pageNumber) {
      let pageData = this.getSearchPageData(pageNumber);
      await this.loadSAWServicePageDataFromServer(pageData);
    },
    onTableLoadData(pageData) {
      this.search(pageData.pageNumber);
    },
    onTablePageSizeChange(value) {
      this.pageSize = value;
    },
    onTableCurrentPageChange(value) {
      this.paginationData.CurrentPage = value;
    },
    onTableEdit(index, row) {
      let navList = [];
      try {
        navList = this.$cryptoJS.enc.Base64.decode(this.routeQuery.navList);
        navList = JSON.parse(navList);
      } catch (error) {}
      navList.push({
        path: this.$route.path,
        data: this.$route.query,
      });
      navList = JSON.stringify(navList);

      let studentId = compileStr(this.saStudent.StudentId.toString());
      let workflowId = "";
      if (row.WorkflowServiceId){
        workflowId = compileStr(row.WorkflowServiceId.toString());
      }
      
      this.$router.push({
        path: "/studyAbroad/studentServiceDetail",
        query: {
          studentId: studentId,
          wsId: workflowId,
          navList: this.$cryptoJS.enc.Base64.encode(navList),
        },
      });
    },
    onTableDelete(index, row) {
      let closeDate = this.$moment().toDate();
      const h = this.$createElement;
      this.$msgbox({
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        message: h("div", null, [
          h(
            "div",
            null,
            `您确定要关闭该服务${
              !!row.ServiceName ? " - " + row.ServiceName : String.empty
            }及其下所有小项吗?`
          ),
          h("div", null, [
            h("span", null, "关闭日期："),
            h("msg-date-picker", {
              props: {
                size: "small",
                format: "yyyy/MM/dd",
                placeholder: "请选择关闭日期",
                value: closeDate,
              },
              on: {
                change(newValue) {
                  closeDate = newValue;
                },
              },
            }),
          ]),
        ]),
      })
        .then(() => {
          closeDate = closeDate || this.$moment().toDate();
          closeDate = this.$moment(closeDate).format("YYYY/MM/DD");
          this.closeSAWorkflowServiceByIdToServer(
            row.WorkflowServiceId,
            closeDate
          );
        })
        .catch(() => {});
    },
    onChannelChange(){
      this.loadSAStudentFromServer();
    }
  },
  watch: {
    saStudent(newValue) {
      this.resetStudentInfoDataIn();
    },
  },
};
</script>

<style lang="scss" scoped>
.student-container {
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  vertical-align: bottom;

  .el-button {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

.cs-studyAbroad-workflow-container {
  padding: 10px 40px 40px 40px;
}
</style>



// WEBPACK FOOTER //
// src/page/studyAbroad/studentServiceList.vue